'use strict';

define('lib/analytics/blocks/error.block',[], function () {
  return function errorBlock(type, pageName) {
    return {
      error_type: type,
      current_pagename: pageName
    };
  };
});

